import events from "@/bl-events"
import { adjustLinks } from "@blinkist/frontend-helpers"

export const init = () => {
  events.on("setup:ready", (config) => {
    // Atm deeplinks in Adjust URLs remove trial screen in the iOS app.
    // Until the app properly handles them, let's remove the deeplink param
    // for visitors without a mobile app.
    document.querySelectorAll(".js-adjust-link").forEach((adjustLink) => {
      if (!config.hasMobileApp) {
        adjustLink.removeAttribute("data-deeplink-path")
      }
    })

    adjustLinks.updateAdjustLinks({
      fingerprint: config.fingerprint,
      abTestVariations: config.test_categories,
      useClassicLinks: !config.has_mobile_app
    })
  })
}
